import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AuthService } from "../../../users/services/auth.service";
import { GlobalVariables } from "../../services/global.service";

@Injectable({
  providedIn: "root",
})
export class UploadService {
  controller = "upload";

  constructor(
    protected http: HttpClient,
    @Inject("BASE_URL") protected baseUrl: string,
    private authService: AuthService
  ) {}

  upload(formData: FormData, folderName: string, secure: boolean = false) {
    return this.http.post(
      this.baseUrl + this.controller + (secure ? "/secure" : "") + "?folder=" + folderName,
      formData
    );
  }

  uploadWithProgress(
    formData: FormData,
    folderName: string,
    maxWidth: number | null = null,
    secure: boolean = false
  ): Observable<any> {
    if (folderName == "") {
      folderName = "documents";
      GlobalVariables.organization.Id
      if (GlobalVariables.organization) folderName += "_" + GlobalVariables.organization.Id;
    }
    return this.http.post(
      this.baseUrl +
        this.controller +
        (secure ? "/secure" : "") +
        "?folder=" +
        folderName +
        "&maxWidth=" +
        maxWidth,
      formData,
      { observe: "events", reportProgress: true }
    );
  }

  uploadMA(
    formData: FormData,
    orgKey: string = "",
    maxWidth: number | null = null,
    secure: boolean = false
  ): Observable<any> {
    return this.http.post(
      this.baseUrl + this.controller + "/public?accessKey=" + orgKey + "&maxWidth=" + maxWidth,
      formData,
      { observe: "events", reportProgress: true }
    );
  }

  uploadTinymce(content: any) {
    return this.http.post(`${this.baseUrl}${this.controller}/tinymce?maxWidth=500`, content);
  }
}
